import { Route, Routes } from 'react-router-dom';
import HomePage from './components/home';
import LoginPage from './components/login';
import DefaultPage from './components/default';
import RegisterPage from './components/register';
import TermsAndConditionsPage from './components/terms-and-conditions';
import StorePage from './components/store';
import OrderPage from './components/order';
import ExamsPage from './components/exams';
import StudentExamsPage from './components/student-exams';
import ExamPage from './components/exam-info';
import QuestionPage from './components/exam';
import ExamReviewPage from './components/exam-review';
import ExamReportPage from './components/exam-report';
import ForgetPasswordPage from './components/forget-password';
import PaymentVerifyPage from './components/payment-verify';
import TimePage from './components/time';
import ChartPage from './components/progress-chart';
import EduSubGroupsPage from './components/edu-sub-groups';
import ExamRankingPage from './components/exam-ranking';
import MahakPage from './components/mahak';
import WebinarPage from './components/webinar';
import StudentQuestionsPage from './components/student-questions';

function App() {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/login' element={<LoginPage />} />
      <Route path='/register' element={<RegisterPage />} />
      <Route path='/forget-password' element={<ForgetPasswordPage />} />
      <Route path='/exams' element={<ExamsPage />} />
      <Route path='/exams/:examId/info' element={<ExamPage />} />
      <Route path='/exams/:examId' element={<QuestionPage />} />
      <Route path='/exams/:examId/review/' element={<ExamReviewPage />} />
      <Route path='/exams/:examId/report' element={<ExamReportPage />} />
      <Route path='/exams/:examId/ranking' element={<ExamRankingPage />} />
      <Route path='/results' element={<StudentExamsPage />} />
      <Route path='/store' element={<StorePage />} />
      <Route path='/orders/:orderId' element={<OrderPage />} />
      <Route path='/progress/chart' element={<ChartPage />} />
      <Route path='/payments/:paymentId/verify' element={<PaymentVerifyPage />} />
      <Route path='/edu-sub-groups' element={<EduSubGroupsPage />} />
      <Route path='/mahak' element={<MahakPage />} />
      <Route path='/wb1406' element={<WebinarPage />} />
      <Route path='/terms-and-conditions' element={<TermsAndConditionsPage />} />
      <Route path='/time' element={<TimePage />} />
      <Route path='/student-questions' element={<StudentQuestionsPage />} />
      <Route path='*' element={<DefaultPage />} />
    </Routes>
  );
}

export default App;
